/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchGetUiAcknowledgementsRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {BatchGetUiAcknowledgementsResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const batchGetUiAcknowledgements = (request: BatchGetUiAcknowledgementsRequest, options?: CashRequestOptions) => post<BatchGetUiAcknowledgementsRequest, BatchGetUiAcknowledgementsResponse>("/2.0/cash/batch-get-ui-acknowledgements", request, {...options, rejectOnError: true })